const NAMESPACE = "common";

const KEYS = {
    loadingMessage: "loadingMessage",
    okText: "okText",
    saveText: "saveText",
    savingText: "savingText",
    editText: "editText",
    deleteText: "deleteText",
    cancelText: "cancelText",
    closeText: "closeText",
    selectText: "selectText",
    continueText: "continueText",
    trueText: "trueText",
    yesText: "yesText",
    noText: "noText",
    numberOneText: "numberOneText",
    numberTwoText: "numberTwoText"
};

const MESSAGES = {
    [KEYS.loadingMessage]: {
        value: "Loading...",
        comment: "Text for general page loading messages"
    },
    [KEYS.okText]: {
        value: "OK",
        comment: "Text for dialog OK buttons"
    },
    [KEYS.saveText]: {
        value: "Save",
        comment: "Text for dialog Save buttons"
    },
    [KEYS.savingText]: {
        value: "Saving...",
        comment: "Text for saving load screens"
    },
    [KEYS.editText]: {
        value: "Edit",
        comment: "Text for dialog Edit buttons"
    },
    [KEYS.deleteText]: {
        value: "Delete",
        comment: "Text for dialog Delete buttons"
    },
    [KEYS.cancelText]: {
        value: "Cancel",
        comment: "Text for dialog cancel buttons"
    },
    [KEYS.closeText]: {
        value: "Close",
        comment: "Text for dialog close button"
    },
    [KEYS.selectText]: {
        value: "Select...",
        comment: "Text for option selector default"
    },
    [KEYS.continueText]: {
        value: "Continue",
        comment: "Text for continue button"
    },
    [KEYS.trueText]: {
        value: "True",
        comment: "Text for True columns"
    },
    [KEYS.yesText]: {
        value: "Yes",
        comment: "Word for affirmation or agreement"
    },
    [KEYS.noText]: {
        value: "No",
        comment: "Word for negation or disagreement"
    },
    [KEYS.numberOneText]: {
        value: "One",
        comment: "Written form of the number 1"
    },
    [KEYS.numberTwoText]: {
        value: "Two",
        comment: "Written form of the number 2"
    }
};

const RESULTS = {
    okResult: "okResult",
    cancelResult: "cancelResult"
};

export { KEYS, NAMESPACE, MESSAGES, RESULTS };
